/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 08:00:56
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { TextStyle } from '@shopify/polaris';
import Banner from 'src/components/views/common/banners/pfs-banner-custom';
import waveIcon from 'src/assets/images/common/wave-minor-warning.png';
import lockIcon from 'src/assets/images/common/lock-icon.png';

type State = {
  activeInfoBanner: boolean
};

type Props = WithI18nProps;
// DONE
class LockCardScopeSuggestion extends Component<Props, State> {
  onClickUnlockButton = () => {
    const { handleUnlock } = this.props;
    handleUnlock();
  };

  render() {
    const { i18n, statusAddon, disableLockUnLock } = this.props;

    return (
      <div className="PFS-scope-suggestion-locked">
        <Banner
          name="lockScopeSuggestion"
          title={i18n.translate('AdminHTML.InstantSearchDisplay.ScopeSuggestionLockBanner.title')}
          titleIcon="rocket"
          status="warning"
          backgroundImage={waveIcon}
          action={{
            content: i18n.translate(
              `AdminHTML.Common.Action.${
                statusAddon === 'restore' ? 'unLockNow' : 'unlockFeatureForTrial'
              }`
            ),
            onAction: () => this.onClickUnlockButton(),
            primary: true,
            icon: lockIcon,
            disabled: disableLockUnLock
          }}>
          <p style={{ minHeight: '72px' }}>
            {i18n.translate('AdminHTML.InstantSearchDisplay.ScopeSuggestionLockBanner.content', {
              t: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.InstantSearchDisplay.ScopeSuggestionLockBanner.content_t'
                  )}
                </TextStyle>
              )
            })}
          </p>
        </Banner>
      </div>
    );
  }
}

export default withI18n()(LockCardScopeSuggestion);
